module.exports = __webpack_public_path__ + "static/img/2.929accf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R600A/2.jpg
// module id = t4GT
// module chunks = 1